export default __webpack_public_path__ + "static/media/covid_life_2.ef339393.jpg";